module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('planoConciliacao.titulos.criteriosConciliacao.novoCriterio'),
      "subTitle": _vm.$t('planoConciliacao.titulos.criteriosConciliacao.novoCriterioInfo')
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.$t('planoConciliacao.titulos.criteriosConciliacao.novoCriterioPortlet')
    }
  }, [_c('form', {
    attrs: {
      "slot": "filters"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validate.apply(null, arguments)
      }
    },
    slot: "filters"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.criteriaConcil.criterioEmUso),
      expression: "criteriaConcil.criterioEmUso"
    }],
    staticClass: "row row-filter-small form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('i', {
    staticClass: "fa fa-info-circle info-icon alert-icon"
  }), _c('span', {
    staticClass: "alert-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.validacao.criterioConcilEmUsoEditar'))
    }
  })])]), _c('div', {
    staticClass: "row row-filter-small form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('span', {
    staticClass: "bold large-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.detalheCriterio'))
    }
  }), _c('br'), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "concilDesc"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.descricaoCriterio'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.criteriaConcil.descricao),
      expression: "criteriaConcil.descricao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'input': true
    },
    attrs: {
      "type": "text",
      "id": "concilDesc",
      "name": "concilDesc",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.criteriaConcil.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.criteriaConcil, "descricao", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('concilDesc', 'required')),
      expression: "errors.firstByRule('concilDesc', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.status'))
    }
  }), _c('div', {
    staticClass: "radio radio-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.criteriaConcil.ativo),
      expression: "criteriaConcil.ativo"
    }],
    attrs: {
      "type": "radio",
      "name": "concilStatus",
      "id": "concilActive"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.criteriaConcil.ativo, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.criteriaConcil, "ativo", true)
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "concilActive"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.ativo'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.criteriaConcil.ativo),
      expression: "criteriaConcil.ativo"
    }],
    attrs: {
      "type": "radio",
      "name": "concilStatus",
      "id": "concilInactive"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.criteriaConcil.ativo, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.criteriaConcil, "ativo", false)
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "concilInactive"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.inativo'))
    }
  })])])]), _c('div', {
    staticClass: "row row-filter-small form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('span', {
    staticClass: "bold large-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.titulos.criteriosConciliacao.abrangencia'))
    }
  }), _c('br'), _c('input-establishment', {
    attrs: {
      "id": "establishmentsFilter",
      "urls": _vm.establishimentsUrls,
      "selectedItems": _vm.selectedEstablishments,
      "disabled": _vm.criteriaConcil.criterioEmUso
    },
    on: {
      "update:selectedItems": function($event) {
        _vm.selectedEstablishments = $event
      },
      "update:selected-items": function($event) {
        _vm.selectedEstablishments = $event
      },
      "update:establishments": function($event) {
        _vm.selectedEstablishments = $event
      }
    }
  })], 1), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('br'), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "diasMinimo"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.diasMinimo'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.criteriaConcil.diasDiferencaMin),
      expression: "criteriaConcil.diasDiferencaMin"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'input': true
    },
    attrs: {
      "type": "number",
      "id": "diasMinimo",
      "name": "diasMinimo",
      "oninput": "javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);",
      "onkeydown": "return event.keyCode !== 69 && event.keyCode !== 187 && event.keyCode !== 189 && event.keyCode !== 109 && event.keyCode !== 107 && event.keyCode !== 106 && event.keyCode !== 111",
      "disabled": _vm.criteriaConcil.criterioEmUso,
      "maxlength": "3"
    },
    domProps: {
      "value": (_vm.criteriaConcil.diasDiferencaMin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.criteriaConcil, "diasDiferencaMin", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('diasMinimo', 'required')),
      expression: "errors.firstByRule('diasMinimo', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('br'), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "diasMaximo"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.diasMaximo'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.criteriaConcil.diasDiferencaMax),
      expression: "criteriaConcil.diasDiferencaMax"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'input': true
    },
    attrs: {
      "type": "number",
      "id": "diasMaximo",
      "name": "diasMaximo",
      "oninput": "javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);",
      "onkeydown": "return event.keyCode !== 69 && event.keyCode !== 187 && event.keyCode !== 189 && event.keyCode !== 109 && event.keyCode !== 107 && event.keyCode !== 106 && event.keyCode !== 111",
      "disabled": _vm.criteriaConcil.criterioEmUso,
      "maxlength": "3"
    },
    domProps: {
      "value": (_vm.criteriaConcil.diasDiferencaMax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.criteriaConcil, "diasDiferencaMax", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('diasMaximo', 'required')),
      expression: "errors.firstByRule('diasMaximo', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })])]), _c('br'), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "valorDiferenca"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.valorDiferenca'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('money', _vm._b({
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "valorDiferenca",
      "name": "valorDiferenca",
      "maxlength": 14,
      "disabled": _vm.criteriaConcil.criterioEmUso,
      "onkeydown": "$event.key === '-' ? $event.preventDefault() : null"
    },
    model: {
      value: (_vm.criteriaConcil.valorDiferencaMax),
      callback: function($$v) {
        _vm.$set(_vm.criteriaConcil, "valorDiferencaMax", $$v)
      },
      expression: "criteriaConcil.valorDiferencaMax"
    }
  }, 'money', _vm.moneyMask, false)), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('valorDiferenca', 'required')),
      expression: "errors.firstByRule('valorDiferenca', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })], 1), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "valorDivergencia"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.valorDivergencia'))
    }
  }), _c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "valorDivergencia",
      "name": "valorDivergencia",
      "maxlength": 14,
      "disabled": _vm.criteriaConcil.criterioEmUso,
      "onkeydown": "$event.key === '-' ? $event.preventDefault() : null"
    },
    model: {
      value: (_vm.criteriaConcil.valorDivergenciaMax),
      callback: function($$v) {
        _vm.$set(_vm.criteriaConcil, "valorDivergenciaMax", $$v)
      },
      expression: "criteriaConcil.valorDivergenciaMax"
    }
  }, 'money', _vm.moneyMask, false))], 1)]), _c('br'), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "occurrenceReason"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.motivoOcorrencia'))
    }
  }), _c('v-select', {
    key: "occurrenceReason",
    class: {
      'input': true
    },
    attrs: {
      "options": _vm.occurrenceReasons,
      "id": "occurrenceReason",
      "name": "occurrenceReason",
      "data-vv-name": "criteriaConcil.motivoOcorrencia",
      "disabled": _vm.criteriaConcil.criterioEmUso,
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "label": "descricao"
    },
    model: {
      value: (_vm.criteriaConcil.motivoOcorrencia),
      callback: function($$v) {
        _vm.$set(_vm.criteriaConcil, "motivoOcorrencia", $$v)
      },
      expression: "criteriaConcil.motivoOcorrencia"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })])], 1)])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "criteriaConcilBank"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.banco'))
    }
  }), _c('v-select', {
    key: "criteriaConcilBank",
    class: {
      'input': true
    },
    attrs: {
      "options": _vm.banks,
      "id": "critBank",
      "name": "critBank",
      "data-vv-name": "criteriaConcil.banco",
      "disabled": _vm.criteriaConcil.criterioEmUso,
      "placeholder": _vm.$t('validacao.select.placeholder')
    },
    on: {
      "input": _vm.changeCritBank
    },
    model: {
      value: (_vm.criteriaConcil.banco),
      callback: function($$v) {
        _vm.$set(_vm.criteriaConcil, "banco", $$v)
      },
      expression: "criteriaConcil.banco"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })])], 1)]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "criteriaConcilAccount"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.conta'))
    }
  }), _c('v-select', {
    key: "criteriaConcilAccount",
    class: {
      'input': true
    },
    attrs: {
      "options": _vm.filteredAccounts,
      "id": "critAccount",
      "name": "critAccount",
      "data-vv-name": "criteriaConcil.conta",
      "disabled": _vm.criteriaConcil.criterioEmUso,
      "placeholder": _vm.$t('validacao.select.placeholder')
    },
    model: {
      value: (_vm.criteriaConcil.conta),
      callback: function($$v) {
        _vm.$set(_vm.criteriaConcil, "conta", $$v)
      },
      expression: "criteriaConcil.conta"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })]), _c('br')], 1)]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('span', {
    staticClass: "bold large-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.titulos.criteriosConciliacao.campoAplicacao'))
    }
  }), _c('button-primary', {
    staticClass: "marged-button",
    attrs: {
      "title": _vm.$t('planoConciliacao.labels.adicionar'),
      "faIcon": "fa fa-plus",
      "id": "btnAddCampoConciliacao",
      "clickFunction": _vm.addConciliationField,
      "disabled": _vm.criteriaConcil.criterioEmUso
    }
  }), _c('br'), _vm._l((_vm.criteriaConcil.conciliacaoCampos), function(field) {
    return _c('div', {
      staticClass: "col-xs-12"
    }, [_c('conciliation-crit-field', {
      key: 'critConcilField' + field.key != undefined && field.key != null ? field.key : field.id,
      ref: 'critConcilField' + field.key != undefined && field.key != null ? field.key : field.id,
      refInFor: true,
      attrs: {
        "id": 'critConcilField' + field.key != undefined && field.key != null ? field.key : field.id,
        "conciliationField": field,
        "disabled": _vm.criteriaConcil.criterioEmUso,
        "mfFieldList": _vm.mfFieldList,
        "mbFieldList": _vm.mbFieldList,
        "attributesCfgMfList": _vm.attributesCfgMfList,
        "attributesMfList": _vm.attributesMfList,
        "conciliationFieldList": _vm.criteriaConcil.conciliacaoCampos
      },
      on: {
        "remove-field-from-criteria-concil": _vm.removeConciliationField,
        "change-conc-field-cfg-mf": _vm.changeFieldAttCfgMf,
        "change-conc-field-att-name-mf": _vm.changeFieldAttNameMf,
        "change-conc-field-mf": _vm.changeFieldAttConciliationFieldMf,
        "change-conc-field-mb": _vm.changeFieldAttConciliationFieldMb,
        "update-attributes-list": _vm.updateAttibutesList
      }
    })], 1)
  })], 2)]), _c('br'), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('planoConciliacao.labels.adicionar'),
      "id": "btnAddCriterioComciliacao",
      "disabled": _vm.requestSent,
      "type": "submit"
    }
  }), _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('planoConciliacao.labels.voltar'),
      "id": "btnRetornaEdicaoPlanoConcil",
      "clickFunction": _vm.back,
      "customClass": "secondary"
    }
  })], 1)]), _c('confirm-modal', {
    attrs: {
      "id": "confirmDivergMax"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-xs-12 row-filter confirm-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.titulos.criteriosConciliacao.modalConfirmaDivergenciaMaxNula'))
    }
  })]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "confirm-buttom",
    attrs: {
      "label": _vm.$t('planoConciliacao.titulos.criteriosConciliacao.modalOpcaoCancelar'),
      "customClass": "secondary",
      "id": "btnFecharModalConfirmaMaxDivergenciaNula",
      "clickFunction": _vm.closeModal
    }
  }), _c('button-primary', {
    staticClass: "pull-right confirm-button",
    attrs: {
      "label": _vm.$t('planoConciliacao.titulos.criteriosConciliacao.modalOpcaoConfirmar'),
      "id": "btnConfirmarModalConfirmaMaxDivergenciaNula",
      "clickFunction": _vm.confirmAdd
    }
  })], 1)])], 1)])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2b0e21fa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b0e21fa"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/registration/conciliationPlan/conciliationCriteria/newConciliationCriteria.pug
// module id = 1387
// module chunks = 0